<!-- Main content -->
<table class="page-break-after-in-print">
    <thead>
        <tr *ngIf="headingNode as node" class="width-100">
            <th class="flex-row {{ node.class }} sticky">
                <ng-container [ngTemplateOutlet]="displayRow" [ngTemplateOutletContext]="{ node: node }"></ng-container>
            </th>
        </tr>
    </thead>

    <tbody class="width-100">
        <!-- This is the tree node template for leaf nodes -->
        <ng-container *ngFor="let node of displayItems; let rowIdex = index">
            <tr
                *ngIf="!node.isHidden"
                class="width-100"
                [ngClass]="{
                    'inActive-row': !node.isRowActive
                }"
                (click)="(node.isAccount || node.isReclasses) && !node.isRowActive && activateAccountRow(rowIdex)"
            >
                <td class="flex-row {{ node.class }}" [ngClass]="{ 'inActive-cell': !node.isRowActive }">
                    <ng-container
                        [ngTemplateOutlet]="displayRow"
                        [ngTemplateOutletContext]="{ node: node, rowIdex: rowIdex }"
                    ></ng-container>
                </td>
            </tr>
        </ng-container>
    </tbody>
    <tfoot>
        <tr class="row-min-height_plus-border-height">
            <td>
                <div class="row-min-height"></div>
            </td>
        </tr>
    </tfoot>
</table>

<!-- Used to render a full row containing several different cells that displays different items -->
<ng-template #displayRow let-node="node" let-rowIdex="rowIdex">
    <ng-container *ngFor="let cell of node.cells; let columnIndex = index">
        <ng-container
            [ngTemplateOutlet]="displayCell"
            [ngTemplateOutletContext]="{
                node: node,
                cell: cell,
                columnIndex: columnIndex,
                rowIdex: rowIdex
            }"
        ></ng-container>
    </ng-container>
</ng-template>

<!-- Used to select one cell out of the previous cells templates giving them the proper size -->
<ng-template #displayCell let-node="node" let-cell="cell" let-columnIndex="columnIndex" let-rowIdex="rowIdex">
    <div
        class="flex-row-inner {{ cell.class }}"
        [ngClass]="{
            'hidden-account-number': node.type === 'RECLASSES' && cell.class === 'title-account-number',
            'hidden-action-cursor': (node.isCollapsed && cell.class === 'action') || node.isAccount
        }"
    >
        <ng-container *ngIf="cell.type === displayTypes.expandAction">
            <div class="padding-width"></div>
            <span
                (click)="collapseExpandChildrenOfRow(node)"
                class="collapsed-icon aumico-pattern-icon"
                [ngClass]="{
                    'aumico-pattern-icon-arrow-right': node.isCollapsed,
                    'aumico-pattern-icon-arrow-down': !node.isCollapsed
                }"
            >
                <i
                    [ngClass]="{
                        'font-12': node.isFLI,
                        'font-10': node.isSubFLI
                    }"
                ></i>
            </span>
        </ng-container>
        <ng-container *ngIf="cell.type === displayTypes.action && !node.isCollapsed">
            <div class="padding-width"></div>
            <span
                (click)="cell.action($event)"
                class="collapsed-icon aumico-pattern-icon {{ cell.extraClass || 'aumico-pattern-icon-arrow-right' }}"
            >
                <i></i>
            </span>
        </ng-container>
        <ng-container
            *ngIf="cell.type === displayTypes.numeric"
            [ngTemplateOutlet]="numberInputTemplate"
            [ngTemplateOutletContext]="{ node: node, cell: cell }"
        >
        </ng-container>
        <ng-container
            *ngIf="!cell.type || cell.type === displayTypes.string"
            [ngTemplateOutlet]="textInputTemplate"
            [ngTemplateOutletContext]="{ node: node, cell: cell }"
        >
        </ng-container>
        <ng-container
            *ngIf="cell.type === displayTypes.date"
            [ngTemplateOutlet]="dateTemplate"
            [ngTemplateOutletContext]="{ node: node, cell: cell }"
        >
        </ng-container>
        <ng-container
            *ngIf="cell.type === displayTypes.translate"
            [ngTemplateOutlet]="textTranslateTemplate"
            [ngTemplateOutletContext]="{ node: node, cell: cell }"
        >
        </ng-container>
        <ng-container
            *ngIf="cell.type === displayTypes.incomeAccount && node.isAccount"
            [ngTemplateOutlet]="incomeSelectOptionTemplate"
            [ngTemplateOutletContext]="{ rowIdex: rowIdex }"
        >
        </ng-container>
    </div>
</ng-template>

<!-- Used to render a cell that has a text value whither editable or not editable  -->
<!-- when editable is true, a from control is passed as well, to handel aum-input -->
<ng-template #textInputTemplate let-node="node" let-cell="cell">
    <div class="padding-width"></div>
    <aum-input *ngIf="cell.editable" [aumFormControl]="cell.control" floatLabel="auto" type="text" simpleInput="true">
    </aum-input>
    <span *ngIf="!cell.editable">
        {{ cell.value }}
    </span>
    <div class="padding-width"></div>
</ng-template>

<!-- Used to render a cell that has a numeric value whither editable or not editable  -->
<!-- when editable is true, a from control is passed as well, to handel aum-input -->
<ng-template #numberInputTemplate let-node="node" let-cell="cell">
    <div class="padding-width"></div>
    <aumico-number-input class="number-input" *ngIf="cell.editable" [control]="cell.control"> </aumico-number-input>
    <span *ngIf="!cell.editable">
        {{ cell.value | finNumber : numberFormat }}
    </span>
    <div class="padding-width"></div>
</ng-template>

<!-- Used to render a cell that has a toggle button to choose which income account will have the copy of change in adjustment -->
<ng-template #incomeSelectOptionTemplate let-rowIdex="rowIdex">
    <div>
        <button
            mat-raised-button
            matTooltip="{{ 'aumico_templates_adjustmentAndReclassed_group_form_tooltip' | i18next }}"
            aum-icon-button
            icon="logout"
            color="basic"
            size="small"
            (click)="copyBalanceChangeInAdjustmentToIncomeAccountAdjustment(rowIdex)"
        ></button>
    </div>
</ng-template>

<!-- Used to render a cell that displays a date  -->
<ng-template #dateTemplate let-node="node" let-cell="cell">
    <span>
        {{ cell.value | dateLocale }}
    </span>
    <div class="padding-width"></div>
</ng-template>

<!-- Used to render a cell that displays a localized text key  -->
<ng-template #textTranslateTemplate let-node="node" let-cell="cell">
    <div class="padding-width"></div>
    <span>
        {{ cell.value | i18next }}
    </span>
    <div class="padding-width"></div>
</ng-template>
